import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-container">
      <div className="about-box">
        {/* <h2 className="about-title"><em>the</em> list</h2>
        <div className="about-form">
          <input type="text" placeholder="FIRST NAME" className="about-input" />
          <input type="email" placeholder="EMAIL ADDRESS" className="about-input" />
          <button className="about-btn">SUBMIT</button>
        </div> */}

        <div className="about-content1">
          <p>
            HospiPharma is a chain of Hospital Pharmacy, a well-recognized OP &
            IP’s pharmacy service provider, Primarily focusing on tier 2&3
            cities across India!
          </p>
        </div>
        <div className="about-content2">
          <p>
            We are one of the fastest growing Hospital Pharmacy Chain with our
            presence across Karnataka and are expanding to other geographies in
            the coming quarters!
          </p>
        </div>
        <div className="about-content3">
          <p>
            The exponential growth is to bring a great value to the Hospitals
            and Healthcare facilities...
          </p>
          {/* <br/> */}
          <div className="about-divider"></div>
          
          <h1 className="about-name">about!</h1>
        </div>
      </div>
    </div>
  );
};

export default About;
